const Spinner = () => <div className="loader" />

export default Spinner
